<template>
	<a :href="resultItem.DocumentUrl" class="c-explist__item">
		<div class="c-explist__item--img">
			<img :alt="resultItem.Title" class="d-none d-xl-block img-fluid"           :src="resultItem.PhotoUrlXL" height="420" width="630" loading="lazy" />
			<img :alt="resultItem.Title" class="d-none d-lg-block d-xl-none img-fluid" :src="resultItem.PhotoUrlLG" height="382" width="510" loading="lazy" />
			<img :alt="resultItem.Title" class="d-none d-md-block d-lg-none img-fluid" :src="resultItem.PhotoUrlMD" height="400" width="532" loading="lazy" />
			<img :alt="resultItem.Title" class="d-none d-sm-block d-md-none img-fluid" :src="resultItem.PhotoUrlSM" height="515" width="687" loading="lazy" />
			<img :alt="resultItem.Title" class="d-block d-sm-none img-fluid"           :src="resultItem.PhotoUrlXS" height="371" width="495" loading="lazy" />
		</div>
		<div class="c-explist__item--inner">
			<div class="c-explist__item--main">
				<h3>{{resultItem.Title}}</h3>
				<p>{{resultItem.Intro}}</p>
				<!--@Umbraco.GetDictionaryValue("General.ReadMore") -> hardcoded lees meer?? searchResults does it that way-->
				<div class="c-explist__item--main--btn"><span>Lees meer</span><i class="fal fa-arrow-right"></i></div>
			</div>
			<div class="c-explist__item--footer">
				<div class="c-explist__item--name">{{resultItem.AuthorName}}</div>
				<div class="c-explist__item--place">{{resultItem.Location}}</div>
			</div>
		</div>
	</a>
</template>

<script>

export default {

	props: {
		resultItem: {
			type: Object,
			required: true
		}
	},
};
</script>
